export default {
    actions: { viewAll: "ดูทั้งหมด", close: "ปิด", add: "เพิ่ม", buyAgain: "ซื้ออีกครั้ง", retry: "ลองอีกครั้ง" },
    status: { loading: "กำลังโหลด…", error: "เกิดข้อผิดพลาด" },
    accessibility: { openMenu: "เปิดเมนู", close: "ปิด", increaseQuantity: "เพิ่มจำนวน", decreaseQuantity: "ลดจำนวน", quickAdd: "เพิ่มลงตะกร้าอย่างรวดเร็ว" }
} as const;
